// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/home/mayo/Projects/takasi/manual-company-manager/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-template-js": () => import("/home/mayo/Projects/takasi/manual-company-manager/src/templates/template.js" /* webpackChunkName: "component---src-templates-template-js" */),
  "component---src-pages-404-js": () => import("/home/mayo/Projects/takasi/manual-company-manager/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/home/mayo/Projects/takasi/manual-company-manager/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

